import { render, staticRenderFns } from "./pcmCseg.vue?vue&type=template&id=86de65ee&scoped=true"
import script from "./pcmCseg.vue?vue&type=script&lang=js"
export * from "./pcmCseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86de65ee",
  null
  
)

export default component.exports